import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { CreateOrEditJurisdictionForm } from "./CreateOrEditJurisdictionForm";
import { Jurisdiction } from "../../../api/jurisdictions/jurisdictionApi";
import { MODAL_CONTENT_SIZING, MODAL_SIZING } from "../../../utils/constants";

interface Props {
    show: boolean;
    onClose: () => void;
    jurisdictionData: Jurisdiction | undefined;
    jurisdictionNames: Jurisdiction[];
    isEdit?: boolean;
}

export const CreateOrEditJurisdictionModal: FunctionComponent<Props> = ({ show, onClose, jurisdictionData, jurisdictionNames, isEdit = false }: Props) => {
    return (
        <Modal isOpen={show} onClose={onClose} size={MODAL_SIZING} isCentered motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent style={{ ...MODAL_CONTENT_SIZING }} overflowY="auto">
                <ModalHeader>
                    <span>{jurisdictionData?.id ? "Edit" : "Add"}</span> Jurisdiction
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody overflowY={"auto"}>
                    <CreateOrEditJurisdictionForm
                        onClose={onClose}
                        jurisdictionData={jurisdictionData}
                        existingJurisdictions={jurisdictionNames}
                        isEdit={isEdit}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
